<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
    <SubTabs nomeSessao="Itens" :tabs="tabs"/>
    <ScheduleModal/>
  </v-container>
</template>

<script>
import SubTabs from '@/components/painel/SubTabs'
import ScheduleModal from '../agendamento/ScheduleModal/'

export default {
  name: 'PItens',
  components: {
    SubTabs,
    ScheduleModal
  },
  data () {
    return {
      tabs: [
        {
          nome: 'Relação',
          url: 'Relacao'
        },
        {
          nome: 'Cupons de Desconto',
          url: 'Cupons'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?fdc7062c